import React from 'react'

const content = (props) => {
  return (
    <div>
      <article>
        <header>
          <p>
            <div>
              {props.text}
            </div>
          </p>
        </header>
      </article>
    </div>)
}

export default content
